module.exports = __webpack_public_path__ + "static/media/css.8d2b071d.png";